import { useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import AddModel from "../../components/Add/AddModel";
import Breadcrumbs from "../../components/breadcrumbs/Breadcrumbs";
import { Tabs } from "../../components/TabSwitch/Tabs";
import AddRaiseETopUpRequest from "./AddRaiseETopUpRequest";
import ListingPayAdvanced from "./ListingPayAdvanced";

const ETopUpRequest = () => {
  const { tab } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  // Redirect to default tab if none provided in URL
  useEffect(() => {
    if (!tab) {
      navigate(`${location.pathname}/raise`, { replace: true });
    }
  }, [tab, location.pathname, navigate]);

  const handleTabChange = (newTab: string) => {
    navigate(`/raise-e-top-up-request/${newTab}`);
  };

  const tabs = [
    {
      id: "raise",
      label: "Raise Request",
      content: <></>,
    },
    {
      id: "pay",
      label: "Pay Advance",
      content: <></>,
    },
  ];

  return (
    <div>
      <Breadcrumbs
        navPath={["Raise E Top Up Request", tab === "pay" ? "Pay Advance" : "Raise Request"]}
        heading={"Raise E Top Up Request"}
        noNavigation
        // links={[ tab === 'pay' ? "/raise-e-top-up-request/pay" : "/raise-e-top-up-request/raise"]}
      />

      {tab !== "pay" ? (
        <AddRaiseETopUpRequest>
          <Tabs
            tabs={tabs}
            defaultTab="raise"
            activeTab={tab}
            setActiveTab={handleTabChange}
          />
        </AddRaiseETopUpRequest>
      ) : (
        <ListingPayAdvanced>
          <Tabs
            tabs={tabs}
            defaultTab="raise"
            activeTab={tab}
            setActiveTab={handleTabChange}
          />
        </ListingPayAdvanced>
      )}
    </div>
  );
};

export default ETopUpRequest;
